import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import DataTable from "react-data-table-component"
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../../../Variables/Global";
import { formatDate } from "../../../../../Classes/Util";
import axiosInstance from '../../../../../api/axiosConfig';
import { getDecodedToken } from '../../../../../utils/utils';

const ListCustomerAccountDebits = (props) => {

    const pId = useParams()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showDeleteDebit, setShowDeleteDebit] = useState(false);
    const handleCloseDeleteDebit = () => setShowDeleteDebit(false);
    const handleShowDeleteDebit = () => setShowDeleteDebit(true);

    const [permissions, setPermissions] = useState([]);

    const [debits, setDebits] = useState([]);
    const [debit, setDebit] = useState({
        amount: 0,
        date: formatDate(new Date()),
        notes: "",
        accountId: pId.AccountId,
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
    })
    const [editingDebitId, setEditingDebitId] = useState(0);
    const [deletingDebitId, setDeletingDebitId] = useState(0);

    const columns = [
        {
            name: 'Debit Amount',
            width: "200px",
            selector: row => row.amount.toLocaleString(),
        },
        {
            name: 'Date',
            width: "200px",
            selector: row => row.date.split("T")[0],
        },
        {
            name: 'Notes',
            selector: row => row.notes,
        },
        {
            name: 'Options',
            width: "130px",
            selector: row => {
                return (
                    <>
                        {permissions.editCustomer === true &&
                            <button className='btn btn-warning  btn-sm ml-1' onClick={() => {
                                setEditingDebitId(row.debitId);
                                setDebit({
                                    amount: row.amount,
                                    date: row.date.split('T')[0],
                                    notes: row.notes,
                                    accountId: pId.AccountId,
                                    userId: localStorage.getItem("uTsReD"),
                                    companyId: localStorage.getItem("C0m8N!"),
                                });
                                handleShow();
                            }}><FiEdit /></button>
                        }
                        {permissions.deleteCustomer === true &&
                            <button className='btn btn-danger btn-sm ml-1' onClick={() => {
                                setDeletingDebitId(row.debitId);
                                handleShowDeleteDebit();
                            }}><FiTrash2 /></button>
                        }
                    </>
                )
            },
        },
    ];

    const [account, setAccount] = useState({
        customerAccount1: ""
    });
    const GetAccount = (accountId) => {
        var config = {
            method: 'get',
            url: "CustomerAccount/GetCustomerAccount/" + accountId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                console.log(response.data)
                setAccount(response.data)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [customer, setCustomer] = useState({
        customerName: ""
    })
    const GetCustomer = (CustomerId) => {
        var config = {
            method: 'get',
            url: "Customer/GetCustomers/" + CustomerId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCustomer(response.data)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const GetDebits = (accountId) => {
        var config = {
            method: 'get',
            url: "Debit/GetDebits?AccountId=" + accountId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setDebits(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const SaveDebit = (e) => {
        e.preventDefault();
        if(editingDebitId === 0){
            var config = {
                method: 'post',
                url: "Debit/AddDebit",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: debit
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        toast.success("Added Successfully")
                        setDebits(response.data);
                        setShow(false)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error("Something Went Wrong")
                });
        }else{
            var config = {
                method: 'put',
                url: "Debit/EditDebit?DebitId="+editingDebitId,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: debit
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        toast.success("Updated Successfully")
                        setDebits(response.data);
                        setShow(false)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error("Something Went Wrong")
                });
        }
    }

    const submitDeleteDebitForm = (e) => {
        e.preventDefault();
        var config = {
            method: 'delete',
            url: "Debit/DeleteDebit?DebitId="+deletingDebitId+"&AccountId="+pId.AccountId+"&UserId="+localStorage.getItem("uTsReD")+"&CompanyId="+localStorage.getItem("C0m8N!"),
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Debit deleted successfully")
                    setDebits(response.data);
                    handleCloseDeleteDebit();
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Something Went Wrong")
            });
    }

    useEffect(() => {
        document.title = 'Account Debits';
        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);
        GetDebits(pId.AccountId);
        GetAccount(pId.AccountId);
        GetCustomer(pId.CustomerId);
    }, [])

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Client Account</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Accounting/Customer">Clients</Link></li>
                                    <li className="breadcrumb-item">
                                        <Link to={"/Accounting/Customer/" + customer.customerId + "/Account/" + account.customerAccountId + "/Statment"}>{customer.customerName} - {account.customerAccount1}</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Debits</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                            <h4 className="card-title">List of Account Debits for {customer.customerName} - {account.customerAccount1}</h4>
                                        </div>
                                        <div className='col-12 col-md-6 text-right'>
                                            {permissions.addCustomer === true && (
                                                <button className="btn btn-primary" 
                                                onClick={() => {
                                                    setEditingDebitId(0);
                                                    setDebit({
                                                        amount: 0,
                                                        date: formatDate(new Date()),
                                                        notes: "",
                                                        accountId: pId.AccountId,
                                                        userId: localStorage.getItem("uTsReD"),
                                                        companyId: localStorage.getItem("C0m8N!"),
                                                    });
                                                    handleShow();
                                                }}
                                                >Add Debit</button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-12">
                                            <DataTable
                                                columns={columns}
                                                data={debits} />
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <Modal size="lg"  show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingDebitId == 0 ? "Add Debit" : "Edit Debit"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Debit Amount</label>
                            <input
                                type="number"
                                className="form-control mb-3"
                                required
                                value={debit.amount}
                                placeholder="Enter the debit amount"
                                onChange={(e) => {
                                    setDebit((prevState) => ({
                                    ...prevState,
                                    amount: e.target.value
                                    }));
                                }}
                                onWheel={(e) => e.target.blur()} // Prevents scrolling from affecting the input
                                />

                        </div>
                        <div className="col-12">
                            <label>Date</label>
                            <input className="form-control mb-3" type="date"
                                value={debit.date}
                                onChange={(e) => {
                                    setDebit((prevState) => ({
                                        ...prevState,
                                        date: e.target.value
                                    }));
                                }}></input>
                        </div>
                        <div className="col-12">
                            <label>Notes</label>
                            <textarea className="form-control"
                                value={debit.notes}
                                onChange={(e) => {
                                    setDebit((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={(e) => SaveDebit(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>
            
            <Modal size="md"  show={showDeleteDebit} onHide={handleCloseDeleteDebit}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Debit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete this debit?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteDebit}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => submitDeleteDebitForm(e)}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
    
}
export default ListCustomerAccountDebits
